import { Tag } from '@nimbus-ds/components';

function Skeleton() {
  return <Tag.Skeleton height="20px" width="70px" />;
}

export default Skeleton;
